/**
 * @module voyager/ng/at-route
 */
import {IDirective, IAttributes, IScope, ITranscludeFunction} from 'angular';
import {main} from '../service/location.js';
import {on, off} from '@acng/frontend-bounty';

type Scope = IScope & {[key: string]: unknown};

export function atRouteDirective(): IDirective<Scope> {
  return {
    scope: false,
    terminal: true,
    transclude: 'element',
    priority: 700,
    restrict: 'A',
    controller: ['$scope', '$element', '$attrs', '$transclude', '$animate', controller],
  };
}


function controller($scope: Scope, $element: JQLite, $attr: IAttributes, $transclude: ITranscludeFunction, $animate: angular.animate.IAnimateService) {
  let childScope: Scope | undefined;
  let childElement: JQLite | undefined;


  const element = $element[0];
  const matches = /^\s*(?<not>!)?\s*(?<name>\w+)/.exec($attr['atRoute'] as string);
  const not = !!matches?.groups?.not;
  /** The route name */
  const name = matches?.groups?.name;
  const route = name ? main.find(name) : null;

  // We need a route object from here on. Without the route we can't do anything.
  if (!route) {
    DEBUG: console.warn(`voyager/ng/at-route "${name}" not found`);
    return;
  }

  const listener = (routeEvent: Event) => {
    /** `true` when Voyager went async, `false` otherwhise */
    const goneAsync = (routeEvent as CustomEvent).detail.goneAsync as boolean;
    DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" change #${$scope.$id} %O`, {routeEvent, goneAsync});

    // Keep it in sync, respecting the current ($locationChange) digest.
    if (!goneAsync) {
      change();
    } else {
      $scope.$apply(change);
    }

    // But maybe it is always better to go async.
    // $scope.$applyAsync(change);
  };

  const change = () => {
    if (route.isActive) {
      not ? leave() : enter();
    } else {
      not ? enter() : leave();
    }
  };

  const enter = () => {
    if (childScope) {
      // elements are already there
      if (!not) {
        for (const i in route.params) {
          childScope[i] = route.params[i];
        }
      }
      return;
    }
    $transclude((clone, newScope) => {
      if (!clone || !newScope) {
        throw new Error('something went wrong');
      }
      childScope = (newScope as Scope);
      childElement = clone;
      if (!not) {
        for (const i in route.params) {
          childScope[i] = route.params[i];
        }
      }
      DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" enter #${$scope.$id}`, {childElement});
      // @ts-expect-error angular-animate lib is bad
      $animate.enter(childElement, null, element);
    });
  };

  const leave = () => {
    DEBUG: route.VERBOSE && console.debug(`voyager/ng/at-route "${name}" leave #${$scope.$id}`);
    if (childScope) {
      childScope.$destroy();
      childScope = undefined;
    }
    if (childElement) {
      $animate.leave(childElement);
      childElement = undefined;
    }
  };

  on(route, 'change', listener);
  $scope.$on('$destroy', () => off(route, 'change', listener));
  change();
}
